import { defineMessages } from 'react-intl';

export default defineMessages({
    firstName: {
        id: 'agentsignup.SignUp.First Name:',
        defaultMessage: 'First Name:'
    },
    lastName: {
        id: 'agentsignup.SignUp.Last Name:',
        defaultMessage: 'Last Name:'
    },
    emailAddress: {
        id: 'agentsignup.SignUp.Email:',
        defaultMessage: 'Email:'
    },
    password: {
        id: 'agentsignup.SignUp.Password:',
        defaultMessage: 'Password:'
    },
    confirmPassword: {
        id: 'agentsignup.SignUp.Confirm Password:',
        defaultMessage: 'Confirm Password:'
    },
    signUp: {
        id: 'agentsignup.SignUp.Sign Up',
        defaultMessage: 'Sign Up'
    },
    fieldEmpty: {
        id: 'agentsignup.SignUp.All fields are required to sign up.',
        defaultMessage: 'All fields are required to sign up.'
    },
    invalidEmail: {
        id: 'agentsignup.SignUp.Please enter a valid email address.',
        defaultMessage: 'Please enter a valid email address.'
    },
    EmailIddoesnotexist: {
        id: 'agentsignup.EmailIddoesnotexist.',
        defaultMessage: 'Cannot send the reset link because email does not exists.'
    },
    DefaultMessage: {
        id: 'agentsignup.SignUp.DefaultMessage.',
        defaultMessage: 'Password reset link not sent.'
    },

    allMandatoryFieldsNotGivenTitle: {
        id: 'agentsignup.SignUp.allMandatoryFieldsNotGivenTitle',
        defaultMessage: 'Mandatory fields validation has failed'
    },
    allMandatoryFieldsNotGivenMessage: {
        id: 'agentsignup.SignUp.allMandatoryFieldsNotGivenMessage.',
        defaultMessage: 'All fields are mandatory to signup a user.'
    },

    emailmandatoryForResendTitle: {
        id: 'agentsignup.SignUp.emailmandatoryForResendTitle',
        defaultMessage: 'Cannot send resend link'
    },
    emailmandatoryForResendMessage: {
        id: 'agentsignup.SignUp.emailmandatoryForResendMessage.',
        defaultMessage: 'Corrrect and registered Email Address is mandatory for Resend Link.'
    },

    EmailIddoesnotexistTitle: {
        id: 'agentsignup.EmailIddoesnotexistTitle',
        defaultMessage: 'Cannot send resend link'
    },
    EmailIddoesnotexistMessage: {
        id: 'agentsignup.EmailIddoesnotexistMessage.',
        defaultMessage: 'Cannot send the resend link because this email is not registered with Producer Engage Portal.'
    },

    cannotCreateUserTitle: {
        id: 'agentsignup.cannotCreateUserTitle',
        defaultMessage: 'User cannot be created'
    },
    cannotCreateUserMessage: {
        id: 'agentsignup.cannotCreateUserMessage.',
        defaultMessage: 'User cannot be created because this email address is already registered.'
    },

    invalidEmailTitle: {
        id: 'agentsignup.invalidEmailTitle',
        defaultMessage: 'Email address is not valid'
    },
    invalidEmailMessage: {
        id: 'agentsignup.invalidEmailMessage.',
        defaultMessage: 'Please provide a valid email address.'
    },

    UpdateValidationTitle: {
        id: 'agentsignup.UpdateValidationTitle',
        defaultMessage: 'Mandatory field validation'
    },
    UpdateValidationMessage: {
        id: 'agentsignup.UpdateValidationMessage.',
        defaultMessage: 'FirstName or LastName  cannot be empty.'
    },

});
